import {Ticket, Knowledge} from '../types';

export function upsertKnowledgeRecord(current: Knowledge[], document: Knowledge): Knowledge[] {
  if (!current.some(item => item.id === document.id)) return [document, ...current];
  return current.map(item => item.id === document.id ? document : item);
}

export function mergeTicketRecords(current: Ticket[], incoming: Ticket[]): Ticket[] {
  const records = new Map(current.map(ticket => [ticket.id, ticket]));
  for (const ticket of incoming) {
    const previous = records.get(ticket.id);
    if (!previous || previous.updated_at <= ticket.updated_at) records.set(ticket.id, ticket);
  }
  return [...records.values()].sort((left, right) => right.created_at.localeCompare(left.created_at)).slice(0, 1000);
}